export default __webpack_public_path__ + "static/exp2-f34fd3b690e61e974215e905901ba146.png";